// MSG-606: the Assistants page's owner-login buttons (Login, Owner Login,
// Copy Login URL, Copy Vyapaar Login URL). A role with `login` gets a full
// owner login; a role with only `readOnlyLogin` gets a read-only one, which
// lasts 30 minutes. The server enforces both — this only picks the endpoint
// and the wording.

export const ownerLoginMode = (assistantPermissions) => {
  const actions = assistantPermissions?.actions || [];
  if (actions.includes("login")) return "full";
  if (actions.includes("readOnlyLogin")) return "readOnly";
  return null;
};

export const ownerLoginEndpoint = (mode) =>
  mode === "readOnly"
    ? "/superadmin/generate-read-only-token"
    : "/superadmin/generate-any-token";

export const ownerLoginLabel = (label, mode) =>
  mode === "readOnly" ? `${label} (Read-only)` : label;

export const loginUrlCopiedMessage = (mode) =>
  mode === "readOnly"
    ? "Read-only login URL copied"
    : "Login URL copied successfully";

// The partner split-button's entries, each keeping its index in `options` —
// handleClick dispatches on that index, so hiding an entry must not shift the
// others. Read-only staff do not get the (full) Partner Dashboard Login.
export const ownerLoginMenu = (options, { mode, partnerId, vyapaarPartnerId }) =>
  options
    .map((label, index) => ({ label, index }))
    .filter(({ label }) => {
      if (label === "Copy Vyapaar Login URL" && partnerId !== vyapaarPartnerId) {
        return false;
      }
      if (label === "Partner Dashboard Login" && mode === "readOnly") {
        return false;
      }
      return true;
    })
    .map(({ label, index }) => ({
      label: label === "Partner Dashboard Login" ? label : ownerLoginLabel(label, mode),
      index,
    }));

// New roles start with read-only owner login on the Assistants node; admins
// tick `login` deliberately.
export const withReadOnlyLoginDefault = (permissionState) =>
  permissionState.map((item) =>
    item.key === "assistants"
      ? { ...item, actions: ["readOnlyLogin"] }
      : item
  );
